export const FILENAME_DATE_FORMAT = 'yyyy-MM-dd-HHmmss';

export const FILENAME_PREFIX = 'flight-export-';

export const KML_EXTENSION = '.kml';

export const KML_MIME_TYPE = 'application/vnd.google-earth.kml+xml';
